import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {InboxService} from '../../../inbox.service';
import {ActivatedRoute, Router} from '@angular/router';
import {RxComponent} from '../../../../common/rx.component';
import {SessionService} from '../../../../../services/session.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ProfileService} from '../../../../profile/profile.service';
import {Observable} from 'rxjs';
import {AlertService} from '../../../../../services/alert.service';

declare var $: any;

@Component({
    selector: 'itpx-conversation-details',
    templateUrl: './conversation-details.component.html',
    styleUrls: ['./conversation-details.component.css']
})
export class ConversationDetailsComponent extends RxComponent implements OnInit {
    private details: any;
    private id: string;
    private username: string;
    private authorName: string;
    private userDomain: String;
    private userAccountName: String;
    private remainingCharAmount: number = 2000;
    private recipientName: string;
    private recipientDomain: string;
    private conversationIdentifier: string;
    private hiddenAlerts: any;
    private isLoading: boolean;
    @ViewChild('postListWrapper') postListWrapper: ElementRef;

    form: FormGroup;

    constructor(
        private inboxService: InboxService,
        private route: ActivatedRoute,
        private sessionService: SessionService,
        private fb: FormBuilder,
        private profileService: ProfileService,
        private alertService: AlertService,
        private router: Router
    ) {
        super()
    }

    ngOnInit() {
        this.isLoading = true;

        this.form = this.fb.group({
            message: [null, Validators.required]
        });

        this.profileService.getProfile()
            .bindToLifecycle(this)
            .subscribe(
                body => {
                    this.authorName = body['data'].name;
                }
            );

        this.username = this.sessionService.getUserDetails().username;
        this.userDomain = this.sessionService.getUserDomain();
        this.route.params
            .map(params => {
                this.id = params['id'];
                this.recipientDomain = params['accountDomain'] ? params['accountDomain'] : null;
                this.conversationIdentifier = this.id ? this.id : this.recipientDomain;
            })
            .flatMap(_ => this.inboxService.getConversationDetails(this.conversationIdentifier).neverError())
            .map(body => {
                this.details = body['data'] ? body['data'] : null;
                this.id = this.details ? this.details.id : null;
                return this.details;
            })
            .flatMap(res => {
                if(res && !Array.isArray(res)) {
                    return this.inboxService.changeConversationStatus({markAsRead: true, idsToUpdate: res.id})
                } else {
                    return Observable.of(res)
                }
            })
            .flatMap(res => {
                if (!this.details ||(this.details && this.details.length === 0)) {
                    return this.inboxService.getAccountDetails({domains: [this.recipientDomain, this.userDomain]})
                } else {
                    return Observable.of({})
                }
            })
            .bindToLifecycle(this)
            .subscribe(
                body => {
                    let dto = body.data;
                    if(Array.isArray(dto)) {
                        this.userAccountName = dto.find(el=> el.domain === this.userDomain).name;
                        this.recipientName = dto.find(el=> el.domain === this.recipientDomain).name;
                    } else {
                        this.userAccountName = this.details.sender.domain === this.userDomain ? this.details.sender.accountName : this.details.recipient.accountName;
                        this.recipientName = this.details.sender.domain === this.userDomain ? this.details.recipient.accountName : this.details.sender.accountName
                    }
                    this.scrollToBottom();
                    this.isLoading = false;
                }
            );

        this.form.controls.message.valueChanges
            .bindToLifecycle(this)
            .subscribe(
                change => {
                    if (change) this.remainingCharAmount = 2000 - this.form.controls.message.value.length
                }
            )
    }
    private scrollToBottom() {
        let self = this;
        setTimeout(function(){
            if (self.postListWrapper) $(self.postListWrapper.nativeElement).scrollTop($(self.postListWrapper.nativeElement)[0].scrollHeight)
        },200);
    }

    private onSubmit() {
        let messageReq = {
            conversationId: this.id,
            message: this.form.controls.message.value,
            author: {
                accountName: this.userAccountName,
                name:  this.authorName,
                domain:  this.userDomain
            }
        };
        if (!this.details || this.details.length === 0) {
            let conversationReq = {
                sender: {
                    accountName: this.userAccountName,
                    domain: this.userDomain
                },
                recipient: {
                    accountName: this.recipientName,
                    domain: this.recipientDomain
                }
            };


            this.inboxService
                .createConversation(conversationReq)
                .filter(res => res && res.data.id)
                .map(res => {
                    if (res) messageReq.conversationId = res.data.id
                })
                .flatMap(_ => this.inboxService.createMessage(messageReq))
                .bindToLifecycle(this)
                .subscribe(
                    body1 => {
                        this.inboxService
                            .informSellerAboutConversation(conversationReq.recipient.domain)
                            .subscribe(
                                body => {
                                    this.router.navigate(['/inbox/conversation/', body1['data'].conversationId, 'details'])
                                }
                            )

                    }
                )

        } else  {
            this.inboxService
                .createMessage(messageReq)
                .flatMap(_ => this.inboxService.getConversationDetails(this.id))
                .bindToLifecycle(this)
                .subscribe(
                    body => {
                        this.details = body['data'];
                        this.form.reset();
                        this.remainingCharAmount = 2000;

                        this.inboxService
                            .informBuyerAboutMessage(this.id)
                            .subscribe(
                                body => {
                                    this.scrollToBottom()
                                }
                            )

                    }
                )
        }
    }
    private onDeleteMessage(e: any) {
        this.inboxService
            .deleteMessage({id: e.id})
            .flatMap(_ => this.inboxService.getConversationDetails(this.id))
            .bindToLifecycle(this)
            .subscribe(
                body => {
                    this.details = body['data'];
                    this.remainingCharAmount = 2000;
                    this.scrollToBottom();
                }
            )
    }

    closeConversationInfo(alertId: string) {
        let userId = this.sessionService.getUserDetails().id;
        this.alertService.hide(alertId, userId);
        this.readCookies();
    }

    private isInfoHidden(alertId: string) {
        this.readCookies();
        return this.hiddenAlerts && this.hiddenAlerts.length ? this.hiddenAlerts.includes(alertId) : false;
    }

    private readCookies() {
        this.hiddenAlerts = this.alertService.readCookie('hide_alert_user_' + this.sessionService.getUserDetails().id);
        this.hiddenAlerts = this.hiddenAlerts ?  this.hiddenAlerts.split(',') : null;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/inbox/common/components/conversation-details/conversation-details.component.ts